import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';

const CLICK_EVENT = 'click';

class ConfirmationModal extends FormComponent {
	constructor(element, config) {
		super(element, config);
		this.id = this.data?.id || 'modal-component';
		this.classNames = this.data?.classNames;
		this.data.id = this.data.id || 'js-confirmation-checkout';
	}
	markup(value, data, titleMarkup) {
		if (!this.data.show) {
			return `<div></div>`;
		}
		return `
            <div class="lta-modal-backdrop lta-modal-backdrop-checkout ${this.data.show ? 'show' : ''}"></div>
            <div 
				id="${data?.id}" 
				class="lta-modal js-checkout-modal u-rounded ${this.data.show ? 'show' : ''}" 
				id="checkout-modal" 
				tabindex="-1" 
				aria-labelledby="true" 
				aria-hidden="true" 
				style="display: block;"
			>
			<div class="lta-modal-dialog">
				<div class="lta-modal-content u-text-center u-mt-1 xl:u-mt-3">
					<p>Are you sure you want to</p>
					<h2 class="u-title2">${this.data.title}</h2>
					${data?.description && `<h2 class="u-caption3">${data.description}</h2>`}
					<div class="lta-modal-dialog-ctas u-flex u-justify-center u-mt-3 u-mb-5 md:u-mt-5">
						<button type="button" class="lta-btn lta-btn--sm lta-btn--secondary lta-checkout-modal-stay u-mt-2 xl:u-mt-0">
							${data?.secondaryButtonLabel}
						</button>
						<button type="button" class="lta-btn lta-btn--sm lta-btn--primary lta-checkout-modal-leave u-ml-0 xl:u-ml-2" id="${this.data?.actionButtonId}">
							${data?.primaryButtonLabel}
						</button>
					</div>
				</div>
			</div>
        `;
	}
	afterRender() {
		this.parentEl = SelectorEngine.findOne(`#${this.data.id}`, this.containerEl);
		if (this.parentEl) {
			this.primaryButton = SelectorEngine.findOne('.lta-modal-content .lta-btn--primary', this.parentEl);
			this.secondaryButton = SelectorEngine.findOne('.lta-modal-content .lta-btn--secondary', this.parentEl);
			this.closeButton = SelectorEngine.findOne('.lta-checkout-modal-dismiss', this.parentEl);
			EventHandler.on(this.primaryButton, CLICK_EVENT, (event) => {
				this.primaryButtonClickHandler(event);
			});
			EventHandler.on(this.secondaryButton, CLICK_EVENT, () => {
				this.secondaryButtonClickHandler();
			});
		}
	}
	validate() {
		return true;
	}
	toggleModal(flag = false) {
		this.data = {
			...this.data,
			show: flag
		};
	}
	primaryButtonClickHandler(event) {
		if (this.data.primaryButtonClick) {
			this.data.primaryButtonClick(event);
		}
		this.toggleModal(false);
	}
	secondaryButtonClickHandler() {
		if (this.data.secondaryButtonClick) {
			this.data.secondaryButtonClick();
		}
		this.toggleModal(false);
	}
}
export default ConfirmationModal;
